import { useState } from 'react';

type Theme = 'dark' | 'light';

export const useTheme = () => {
    const [theme, setTheme] = useState<Theme>(() => document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light');

    const toggleTheme = () => {
        const next = theme === 'dark' ? 'light' : 'dark';
        document.documentElement.dataset.theme = next;
        document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute('content', next === 'dark' ? '#171d2a' : '#f5f6fa');
        try { localStorage.setItem('itansar-theme', next); } catch { /* The theme remains usable without storage. */ }
        setTheme(next);
    };

    return { theme, toggleTheme };
};
